import { AuthProvider, useAuth } from './auth/AuthProvider';
import { ConfigProvider } from './config/ConfigProvider';
import { NotificationProvider } from './messaging/NotificationProvider';
import { MessagingMount } from './messaging/MessagingMount';
import { AppShell } from './screens/AppShell';
import { LoginScreen } from './screens/LoginScreen';
import { ConfirmProvider, ErrorBoundary, ToastProvider } from './ui';
import { StagingBanner } from './ui/StagingBanner';

function Root() {
  const { user } = useAuth();
  return user ? <AppShell /> : <LoginScreen />;
}

export function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ConfigProvider>
          <ToastProvider>
            <ConfirmProvider>
              <NotificationProvider>
                {/* Outside Root so it shows on the LOGIN screen too — you must know the tier before you
                    type a password, not after. Renders nothing at all on production. */}
                <StagingBanner />
                <Root />
                {/* The notification bell lives in the nav (Sidebar); this mounts the messaging drawer once. */}
                <MessagingMount />
              </NotificationProvider>
            </ConfirmProvider>
          </ToastProvider>
        </ConfigProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}
